import { useState, type VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import { Action } from '../../../../../../typings/permissions';
import useHasProjectPermission from '../../../../../shared/permissions/useHasProjectPermission';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../../generic/Button';
import Flex from '../../../../generic/Flex';
import type { NoticeMatch } from '../../../../../../shared/types/routes/revisions';

import { DependencyNotice } from './DependencyNotice';
import { DependencyNoticeEditing } from './DependencyNoticeEditing';

import styles from '../DependencyDrawer.module.less';

type Props = {
  key: string;
  notice: NoticeMatch;
  dependencyRevisionLocator: string;
};

export const NoticeFileItemContainer: VoidFunctionComponent<Props> = ({
  key,
  notice,
  dependencyRevisionLocator,
}) => {
  const canEdit = useHasProjectPermission(Locator.parsePackageString(dependencyRevisionLocator), Action.Edit);
  const [isEditing, setIsEditing] = useState(false);

  const onToggleEdit = () => {
    setIsEditing(!isEditing);
  };

  return (
    <div key={key}>
      <div className={styles.noticePath}>
        <Flex justify="space-between">
          <div>
            <span className={styles.pathLabel}>File path: </span>
            <span>{notice.path}</span>
          </div>
          {canEdit && !isEditing && (
            <Button type={BUTTON_TYPE.SECONDARY} size={BUTTON_SIZE.MEDIUM} onClick={onToggleEdit}>
              Edit
            </Button>
          )}
        </Flex>
      </div>
      {isEditing ? (
        <DependencyNoticeEditing
          dependencyRevisionLocator={dependencyRevisionLocator}
          notice={notice}
          onToggleEdit={onToggleEdit}
        />
      ) : (
        <DependencyNotice notice={notice} />
      )}
    </div>
  );
};
